import React from 'react'
import { Wrapper } from './BookInfo.styles'
import type { BookInfoProps } from './BookInfo.types'
import BookModal from '../book-modal/BookModal'

const BookInfo: React.FC<BookInfoProps> = ({
  format,
  title,
  author,
  imageUrlThumb,
  slug,
  children,
  setIsOpen,
  isOpen,
  additionalActions,
  language,
  contentType,
  loanActionInfo
}) => {
  const resolvedContentType =
    contentType ?? (format === 'book' ? 'book' : 'article')

  return (
    <Wrapper format={format} data-testid="info-book">
      {isOpen && (
        <div data-testid="modal-infobook">
          <BookModal
            language={language}
            setIsOpen={setIsOpen}
            title={title}
            author={author}
            slug={slug}
            imageUrlThumb={imageUrlThumb}
            additionalActions={additionalActions}
            contentType={resolvedContentType}
            loanActionInfo={loanActionInfo}
          />
        </div>
      )}
      {children}
    </Wrapper>
  )
}

export default BookInfo
